import { apiClient } from './client'

export { apiClient, handleApiRequest, ApiErrorResponse, CancelledApiCall } from './client'
export { authApi, sessionApi } from './auth'
export { ultraadminApi } from './ultraadmin'
export { superadminApi } from './superadmin'
export { adminApi } from './admin'
export { teacherApi } from './teacher'
export { timetableApi } from './timetable'
export { timetableImportApi } from './timetableImport'
export { isImportCancelled, timetableImportV2Api } from './timetableImportV2'
export { timetableStructuresApi } from './timetableStructures'
export { parsingCorrectionsApi } from './parsingCorrections'
export { confidenceApi } from './confidence'
export { teacherCodeApi } from './teacherCode'
export { templateTrainingApi } from './templateTraining'
export { teachersApi } from './teachers'
export { patternPipelineApi, schoolPatternApi } from './patternPipeline'
export { hrApi } from './hr'
export { absenceTypesApi } from './absenceTypes'

export const api = {
  get: <T = any>(url: string) => apiClient.get<T>(url).then(r => r.data),
  post: <T = any>(url: string, data?: any) => apiClient.post<T>(url, data).then(r => r.data),
  put: <T = any>(url: string, data?: any) => apiClient.put<T>(url, data).then(r => r.data),
  delete: <T = any>(url: string) => apiClient.delete<T>(url).then(r => r.data),
}

export type { UserRoleInfo, UserListResponse, UserCreateRequest, RoleActionResponse } from './superadmin'
export type { TeacherInfo, TeacherListResponse, TeacherCreateRequest, TeacherUpdateRequest, AdminInfo, AdminListResponse, AdminCreateRequest, SubstitutionStatsResponse } from './admin'
